export default {"src":"/_next/static/media/how-1.670a5694.svg","height":83,"width":112,"blurWidth":0,"blurHeight":0};